import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";

@Component({
  selector: 'app-multiline-dropdown-input',
  templateUrl: './multiline-dropdown-input.component.html',
  styleUrls: ['./multiline-dropdown-input.component.scss']
})
export class MultilineDropdownInputComponent implements OnInit {
  @Output() selectValueChanged = new EventEmitter();
  @ViewChild('input') input: ElementRef;

  @Input() options = Array<{value: string, text: string, line1: string, line2: string }>();
  @Input() selectedValue = '';
  @Input() placeholder = '';
  @Input() name: string;
  @Input() parentForm: UntypedFormGroup;
  @Input() className = '';

  selectedValueText = '';
  isFocused = false;
  hasPlaceholder = false;

  ngOnInit(): void {
    if (this.selectedValue !== '') {
      for (const option of this.options) {
        if (this.selectedValue === option.value) {
          this.selectedValueText = option.text;
        }
      }
    } else {
      this.setPlaceholder();
    }
  }

  reset() {
    this.selectedValue = '';
    this.setPlaceholder();
  }

  setPlaceholder() {
    this.hasPlaceholder = true;
    this.selectedValueText = this.placeholder;
  }

  onItemSelect(index: number) {
    const option = this.options[index];
    this.selectedValue = option.value;
    this.selectedValueText = option.text;
    this.hasPlaceholder = false;
    this.input.nativeElement.value = option.value;
    this.selectValueChanged.emit(option.value);
    this.onClose();
  }

  setValue(value: string) {
    let i = 0;
    for (const option of this.options) {
      if (option.value === value) {
        this.onItemSelect(i);
      }
      i++;
    }
  }

  onBlur() {
    this.isFocused = false;
  }

  onOpen() {
    this.isFocused = !this.isFocused;
  }

  onClose() {
    this.isFocused = false;
  }

}
